export const TASK_STATUS_VALUES = ['IN_PROGRESS', 'FAILED', 'COMPLETED'] as const
export type TaskStatus = (typeof TASK_STATUS_VALUES)[number]

export const USER_TASK_TYPE_VALUES = ['CONFIRM_GOODS_RECEIVED', 'APPROVE_BILL'] as const
export const SYSTEM_TASK_TYPE_VALUES = [
  'ACCOUNTING_RECEIPT_PUSH',
  'ACCOUNTING_PURCHASE_ORDER_POLL',
  'ACCOUNTING_CHANGE_ORDER_POLL',
  'ACCOUNTING_RECEIPT_VOID',
  'ACCOUNTING_BILL_PUSH',
  'BILL_EXTRACTION',
  'BILL_MATCHING',
  'BILL_CODING',
] as const
export const TASK_TYPE_VALUES = [...USER_TASK_TYPE_VALUES, ...SYSTEM_TASK_TYPE_VALUES] as const
export type TaskType = (typeof TASK_TYPE_VALUES)[number]

export const TASK_ENTITY_TYPE_VALUES = ['purchase-order', 'change-order', 'receipt', 'bill'] as const
export type TaskEntityType = (typeof TASK_ENTITY_TYPE_VALUES)[number]

export enum RequestStepTaskTypeEnum {
  /** Sync supplier data in external accounting software */
  ACCOUNTING_SUPPLIER_DATA_SYNC = 'ACCOUNTING_SUPPLIER_DATA_SYNC',
  /** Generate a document into a rich text answer */
  CONTENT_GENERATION = 'CONTENT_GENERATION',
  ESIGN_FILL_IN = 'ESIGN_FILL_IN',
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  /** Create PO in external accounting software */
  EXTERNAL_PO_CREATION = 'EXTERNAL_PO_CREATION',
  FILL_IN = 'FILL_IN',
  REVIEW = 'REVIEW',
  /** Set up the sourcing event */
  RFX_SETUP = 'RFX_SETUP',
  /** Scoring task for an RFx evaluation criterion */
  SCORE_RFX_CRITERION = 'SCORE_RFX_CRITERION',
  /** Scoring task for a particular RFX form */
  SCORE_RFX_FORM = 'SCORE_RFX_FORM',
  SUMMARY_APPROVAL = 'SUMMARY_APPROVAL',
}

export enum TaskState {
  REQUIRED = 'REQUIRED',
  WAITING_OTHER_TASKS = 'WAITING_OTHER_TASKS',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  REJECTED = 'REJECTED',
  AWAITING_AMENDMENT = 'AWAITING_AMENDMENT',
  AMENDMENT_REQUIRED = 'AMENDMENT_REQUIRED',
}
